// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bhs_tr","LeftMenu__link":"ir_b bhs_vt bhs_a bhs_rc","LeftMenu__link__icon":"ir_c"};